import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Image } from 'src/app/shop';
import { ShopifyMedia } from 'src/app/shop/models/Media.model';
import { ShopifyMediaItemComponent } from '../shopify-media-item/shopify-media-item.component';

@Component({
  selector: 'app-collection-header',
  templateUrl: './collection-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ShopifyMediaItemComponent],
})
export class CollectionHeaderComponent {
  @Input() title!: string;
  @Input() text!: string;
  @Input() image!: any;
  @Input() imageWide = false;

  get shopifyMedia(): ShopifyMedia {
    return {
      id: this.image.id,
      mediaContentType: 'MEDIAIMAGE',
      alt: this.image.altText,
      previewImage: this.image,
      //sources?: {
      //  url: string;
      //  format: string;
      //}[];
    };
  }
}
